// DS: i1.15
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const DreamUpStars: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.02 19.65a2.6 2.6 0 0 1 1.63-1.63l1.35-.45-1.35-.45a2.57 2.57 0 0 1-1.63-1.63l-.45-1.35-.45 1.35a2.57 2.57 0 0 1-1.63 1.63l-1.35.45 1.35.45a2.6 2.6 0 0 1 1.63 1.63l.45 1.35.45-1.35ZM6.88 14.5c.25-.77.86-1.38 1.62-1.63l1.36-.45-1.36-.45a2.57 2.57 0 0 1-1.62-1.63L6.43 9l-.45 1.35a2.57 2.57 0 0 1-1.63 1.63L3 12.43l1.35.45c.77.25 1.37.86 1.63 1.63l.45 1.35.45-1.35ZM15 15l-.87-2.6a4 4 0 0 0-2.53-2.53L9 9l2.6-.87a4 4 0 0 0 2.53-2.53L15 3l.87 2.6a4 4 0 0 0 2.53 2.53L21 9l-2.6.87a4 4 0 0 0-2.53 2.53L15 15Z"
      />
    </svg>
  </IconWrap>
);
DreamUpStars.displayName = 'DreamUpStars';

export default DreamUpStars;
